import React, { useState } from 'react';
import { Button, Input } from 'rsuite';
import api from '../../../services/api';
import RModal from '../../../components/Rsuite/Modal';
import { Container, ContainerInterno } from './styles';
import theme from '../../../theme';
import { CustomCheckPicker } from '../../../components/CustomCheckPicker';
import { Spacer } from '../../../components/Spacer';
import { toastSuccess, toastWarning } from '../../../toasts';

const AlterarTaxasLote = ({ open, close, bairros, setBairros }) => {
  const [desabilitar, setDesabilitar] = useState(false);
  const [idBairros, setIdBairros] = useState([]);
  const [taxa, setTaxa] = useState(0);
  const bairrosSelect = Array.isArray(bairros)
    ? bairros.map((obj) => ({ value: obj.Id, label: obj.Bairro }))
    : [];

  const selectAll = () => {
    const neighborhoodIds = bairrosSelect.map(
      (neighborhood) => neighborhood.value,
    );

    setIdBairros(neighborhoodIds);
  };

  const salvar = async () => {
    setDesabilitar(true);
    if (idBairros && idBairros.length > 0) {
      await api
        .post('bairro/alterarTaxasLote', {
          Taxa: taxa,
          Bairros: idBairros,
        })
        .then((res) => {
          res.data.map((response) => {
            setBairros((state) =>
              state.map((e) => (e.Id !== response.Id ? e : response)),
            );
          });
          toastSuccess('Taxas alteradas com sucesso');
          close();
        });
    } else {
      toastWarning('Nenhum bairro informado');
    }
    setDesabilitar(false);
  };

  return (
    <RModal
      open={open}
      onClose={close}
      footer={
        <>
          <Button onClick={selectAll} appearance="ghost">
            Selecionar todos
          </Button>

          <Spacer flex={1} />

          <Button onClick={salvar} appearance="primary" disabled={desabilitar}>
            Salvar
          </Button>

          <Button onClick={close} appearance="ghost">
            Fechar
          </Button>
        </>
      }
    >
      <Container>
        <ContainerInterno>
          <CustomCheckPicker
            placeholder="Selecione os bairros para alteração"
            data={bairrosSelect}
            value={idBairros}
            defaultValue={''}
            onChange={setIdBairros}
          />
        </ContainerInterno>
      </Container>
      <Container>
        <ContainerInterno>
          <label htmlFor="bairro">
            <b style={{ color: theme.cores.black }}>Taxa de Entrega</b>
          </label>
          <Input
            style={{ width: '100%' }}
            type="number"
            placeholder="Bairro"
            value={taxa}
            onChange={setTaxa}
          />
        </ContainerInterno>
      </Container>
    </RModal>
  );
};

export default AlterarTaxasLote;
